"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskBase () {
        return AutoflowTaskBase;
    },
    get AutoflowTaskBaseResponse () {
        return AutoflowTaskBaseResponse;
    },
    get AutoflowTaskConfigBase () {
        return AutoflowTaskConfigBase;
    },
    get AutoflowTaskInputs () {
        return AutoflowTaskInputs;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const AutoflowTaskInputs = _zod.z.record(_zod.z.string(), _zod.z.any());
const AutoflowTaskConfigBase = _zod.z.object({
    company_id: _zod.z.instanceof(_bson.ObjectId).optional()
});
const AutoflowTaskBase = _zod.z.object({
    task_id: _zod.z.string(),
    task_type: _zod.z.string(),
    config: AutoflowTaskConfigBase,
    inputs: AutoflowTaskInputs.optional(),
    retries: _zod.z.number().default(3)
});
const AutoflowTaskBaseResponse = AutoflowTaskBase.extend({
    error: _zod.z.string().optional(),
    outputs: _zod.z.array(_zod.z.any())
});
